import React from 'react'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'

const Footer = () => {
    const { t } = useTranslation()

    return (
        <footer className="bg-[hsl(220,26%,14%)] text-white/70">
            <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-sm">{t('footer.copyright')}</p>
                    <nav className="flex items-center gap-6">
                        <Link to="/documentation" className="text-sm hover:text-white transition-colors">
                            {t('nav.documentation')}
                        </Link>
                        <Link to="/pricing" className="text-sm hover:text-white transition-colors">
                            {t('nav.pricing')}
                        </Link>
                        <Link to="/contact" className="text-sm hover:text-white transition-colors">
                            {t('nav.contact')}
                        </Link>
                    </nav>
                </div>
            </div>
        </footer>
    )
}

export default Footer
